import { signaliumAsyncTransform } from './async.js';
import { signaliumCallbackTransform } from './callback.js';
import { signaliumPromiseMethodsTransform } from './promise.js';
import { signaliumUseReactiveTransform } from './use-reactive.js';
import { isBabelApi } from './utils.js';
// Babel preset that sequences the two plugins just like separate entries
// Usage in babel config: presets: [[require('signalium/transform').signaliumPreset(options)]
function createSignaliumPreset(api, opts) {
    return {
        plugins: [
            signaliumCallbackTransform({
                transformedImports: opts?.transformedImports ?? [],
                importPaths: opts?.importPaths,
                callbackImportPath: opts?.callbackImportPath,
            }),
            signaliumAsyncTransform({ transformedImports: opts?.transformedImports ?? [], importPaths: opts?.importPaths }),
            signaliumUseReactiveTransform({
                transformedImports: opts?.transformedImports ?? [],
                importPaths: opts?.importPaths,
                reactImportPath: opts?.reactImportPath,
            }),
            signaliumPromiseMethodsTransform({
                transformedImports: opts?.transformedImports ?? [],
                importPaths: opts?.importPaths,
                promiseImportPath: opts?.promiseImportPath,
            }),
        ],
    };
}
export function signaliumPreset(apiOrOpts, maybeOpts) {
    if (isBabelApi(apiOrOpts)) {
        return createSignaliumPreset(apiOrOpts, maybeOpts);
    }
    return (api) => createSignaliumPreset(api, apiOrOpts);
}
